export enum QUERY_KEYS {
  createInvitation = 'create-invitation',
  deleteInvitation = 'delete-invitation',
  editInvitation = 'edit-invitation',
  getEventInvitations = 'get-event-invitations',
  getInvitation = 'get-invitation',
}
